import axios from 'axios'
import router from '@/router'
const api17Sys = axios.create({
  baseURL: process.env.VUE_APP_API_SYS_URL,
})
api17Sys.defaults.headers.post['Content-Type'] =
  'application/json; charset=utf-8'
api17Sys.defaults.withCredentials = true

api17Sys.interceptors.response.use(
  response => {
    switch (response.data.code) {
      case 1000:
        return Promise.resolve(response.data)
    }
    return Promise.reject(response.data)
  },
  err => {
    if (err && err.response) {
      switch (err.response.status) {
        case 404:
          console.log('找不到該頁面')
          break
        case 500:
          router.replace('/error?errorCode=500')
          break
        case 503:
          console.log('服務失效')
          break
        default:
          console.log(`連接錯誤${err.response.status}`)
      }
    } else {
      if (err.message.includes('timeout')) {
        console.log('time out')
        router.replace('/error?errorCode=Time_Out')
      } else if (err.code) {
        // router.replace('/error?errorCode=' + err.code)
      } else {
        router.replace('/error?errorCode=' + JSON.parse(err))
      }
    }
    return Promise.reject(err.response)
  }
)

window.apiSys = {}

apiSys.getAesParameter = async channelToken => {
  const res = await api17Sys.post('GetAesParameter', {
    channelToken: channelToken,
  })
  return res
}

apiSys.getTokenInfo = async (data, checkSum) => {
  const res = await api17Sys.post('GetTokenInfo', {
    Data: data,
    checkSum: checkSum,
  })

  return res
}
